module.exports = __webpack_public_path__ + "img/gg.81c48b3f.png";